import { Card, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SeasonStanding from "./SeasonStanding";
import RecentGames from "./RecentGames";
import UpcomingGames from "./UpcomingGames";
import { useAuth } from "../context/AuthContext";
import { useRequest } from "../hooks/useRequest";
import { getSeasonUrl } from "../config/api";
import { Season } from "../types/models";

function AdminSeasonOverviewPage() {
  const { seasonId } = useParams();
  const auth = useAuth();

  const { data: season } = useRequest<Season>(
    seasonId ? getSeasonUrl(parseInt(seasonId)) : undefined,
    auth.token,
  );

  const seasonName = season?.name || `Season ${seasonId}`;

  return (
    <div className="mt-4">
      <h3 className="mb-4">{seasonName} Overview</h3>

      <Row className="g-3">
        <Col md={6}>
          <Card>
            <Card.Header>
              <Card.Title className="mb-0">Recent Games</Card.Title>
            </Card.Header>
            <Card.Body>
              {seasonId && (
                <RecentGames seasonId={parseInt(seasonId)} limit={5} />
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card>
            <Card.Header>
              <Card.Title className="mb-0">Upcoming Games</Card.Title>
            </Card.Header>
            <Card.Body>
              {seasonId && (
                <UpcomingGames seasonId={parseInt(seasonId)} limit={5} />
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col md={12}>
          {seasonId && (
            <SeasonStanding seasonId={parseInt(seasonId)} title="Standings" />
          )}
        </Col>
      </Row>
    </div>
  );
}

export default AdminSeasonOverviewPage;
